import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorPlaceOfBirthFieldProps {
  control: Control<CryptorFormData, {}>;
}

const CryptorPlaceOfBirthField: FC<CryptorPlaceOfBirthFieldProps> = ({
  control,
}) => {
  return (
    <Controller
      control={control}
      name="placeOfBirth"
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Lieu de naissance"
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default CryptorPlaceOfBirthField;
